'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(Direction2) {
  Direction2[Direction2["NONE"] = 0] = "NONE";
  Direction2[Direction2["DOWN"] = 1] = "DOWN";
  Direction2[Direction2["UP"] = 2] = "UP";
})(exports.Direction || (exports.Direction = {}));
class ScrollService {
  constructor() {
    this.rootElement = document.body;
    this.isScrollingEnabled = true;
    this.lastTouchPosition = 0;
    this.setLastTouchLocation = (event) => {
      this.lastTouchPosition = event.touches[0].clientY;
    };
    this.preventScrolling = (event) => {
      if (!event.cancelable) {
        return;
      }
      const direction = this.getDirection(event);
      if (event.composedPath) {
        const scrollable = event.composedPath().some((element) => {
          return this.isScrollable(element, direction);
        });
        if (!scrollable) {
          event.preventDefault();
        }
        return;
      }
      let currTarget = event.target;
      while (currTarget instanceof Element) {
        if (this.isScrollable(currTarget, direction)) {
          event.preventDefault();
          return;
        }
        currTarget = currTarget.parentElement;
      }
    };
  }
  onScroll(handler, elementOrWindow = window) {
    elementOrWindow.addEventListener("scroll", handler, { passive: true });
    return () => {
      elementOrWindow.removeEventListener("scroll", handler);
    };
  }
  scrollTo(element, useOffset = false) {
    if (!useOffset) {
      element.scrollIntoView({
        behavior: "smooth"
      });
      return;
    }
    const parent = scroll.findScrollableParent(element);
    if (parent) {
      const contentElement = document.getElementById("content");
      const offsetTop = parseInt(getComputedStyle(contentElement).getPropertyValue("padding-top"), 10) || 0;
      const top = element.getBoundingClientRect().top - offsetTop;
      parent.scrollBy({
        top,
        behavior: "smooth"
      });
    }
  }
  scrollToTop() {
    window.scrollTo(0, 0);
  }
  setRootElement(rootElement) {
    this.rootElement = rootElement;
  }
  disableScrolling() {
    if (!this.isScrollingEnabled) {
      return;
    }
    this.lastTouchPosition = 0;
    this.isScrollingEnabled = false;
    document.body.classList.add("no-scroll");
    window.addEventListener("wheel", this.preventScrolling, {
      passive: false
    });
    window.addEventListener("touchstart", this.setLastTouchLocation, {
      passive: false
    });
    window.addEventListener("touchmove", this.preventScrolling, {
      passive: false
    });
  }
  enableScrolling() {
    if (this.isScrollingEnabled) {
      return;
    }
    this.lastTouchPosition = 0;
    this.isScrollingEnabled = true;
    document.body.classList.remove("no-scroll");
    window.removeEventListener("wheel", this.preventScrolling);
    window.removeEventListener("touchstart", this.setLastTouchLocation);
    window.removeEventListener("touchmove", this.preventScrolling);
  }
  findScrollableParent(element) {
    let currTarget = element.parentElement;
    while (currTarget) {
      if (this.isScrollable(currTarget, 1) || this.isScrollable(currTarget, 2)) {
        return currTarget;
      }
      const shadowRoot = currTarget.getRootNode();
      currTarget = currTarget.parentElement || (shadowRoot ? shadowRoot.host : null);
    }
    return window;
  }
  getDirection(event) {
    const { changedTouches } = event;
    if (changedTouches) {
      const currentPos = changedTouches[0].clientY;
      const isUp = this.lastTouchPosition < currentPos;
      return isUp ? 2 : 1;
    }
    const { deltaY } = event;
    return deltaY && deltaY > 0 ? 1 : 2;
  }
  isScrollable(element, direction) {
    if (element === this.rootElement || element === document.scrollingElement) {
      return false;
    }
    if (element instanceof Window) {
      return false;
    }
    if (element instanceof Element) {
      const { scrollTop, scrollHeight, clientHeight } = element;
      const hasScrollbar = scrollHeight >= clientHeight;
      if (!hasScrollbar) {
        return false;
      }
      const atTop = scrollTop <= 0;
      const atBottom = scrollHeight - scrollTop === clientHeight;
      const isUp = direction === 2;
      const isDown = direction === 1;
      const atBounds = atTop && isUp || atBottom && isDown;
      if (atBounds) {
        return false;
      }
      const styles = getComputedStyle(element);
      return ["hidden", "visible"].indexOf(styles.overflowY) === -1;
    }
    return false;
  }
}
const scroll = new ScrollService();

exports.ScrollService = ScrollService;
exports.scroll = scroll;
